import React, { useState } from "react";

import Container from "../shared/container";

import { __t } from "../../utils/translate";
import { FaqType } from "../../utils/types";

type FaqProps = {
    faq: FaqType;
};

const Faq: React.FC<FaqProps> = ({
    faq,
}) => {
    const [openIndex, setOpenIndex] = useState(0);

    const handleFaqClick = (index: number) => {
        setOpenIndex(openIndex === index ? 0 : index);
    };

    return (
        !!faq && (
            <Container>
                <div className="py-14 lg:py-8 lg:max-w-[918px] mx-auto">
                    <h2 className="text-price md:text-h2 text-center text-main-text-color pb-8 sm:pb-10">
                        {faq.title}
                    </h2>
                    {faq.items.map((item: any, index) => {
                        const question = item.title ? item.title : '';
                        const answer = item.content ? item.content : '';

                        const isCurrentOpen = openIndex === index;
                        // const height = isCurrentOpen ? totalHeight : 0;

                        return (
                            <div
                                key={index}
                                className={`flex flex-col w-full border-t-[1px] first:border-t-0 last:border-b-[1px] border-collapse border-stroke-color`}
                            >
                                <div
                                    onClick={() => {
                                        handleFaqClick(index);
                                        // const newHeight = isCurrentOpen ? 0 : document.getElementById(`faq-answer-${index}`)?.clientHeight || 0;
                                        // setTotalHeight(newHeight);
                                    }}
                                    className="flex flex-row justify-between py-5 md:p-[30px] px-4 cursor-pointer gap-2 z-10"
                                >
                                    <div className="text-base-16-strong md:text-title text-main-text-color md:text-dark !font-semibold w-fit" dangerouslySetInnerHTML={{ __html: question }}></div>
                                    <svg className="w-fit" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        {isCurrentOpen === false && (
                                            <path d="M12 5V19" stroke="#405465" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        )}
                                        <path d="M5 12H19" stroke="#405465" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>

                                </div>
                                <div
                                    className={`overflow-hidden ease-in-out transition-all duration-500 h-max
                                    ${isCurrentOpen ? 'max-h-[1000px] border-t border-[#B6C5D1]' : 'max-h-0'}`}>
                                    <div
                                        id={`faq-answer-${index}`}
                                        className={`text-base-16 md:text-h3-r py-5 md:py-6 border-collapse bg-light-blue px-4`}
                                        dangerouslySetInnerHTML={{ __html: answer }}
                                    ></div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Container>

        )
    );
};

export default Faq;
